export { default as fanta } from './fanta';
export { default as horizon } from './horizon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/ThemeProvider/themes/index.js
// module id = 2027
// module chunks = 12